import { Skeleton } from "@mui/material";
import { type FC } from "react";

import * as Styled from "./EventMetrics.styles";

const METRIC_COUNT = 4;
const CARD_MIN_WIDTH = 150;
const CARD_HEIGHT = 64;

export const EventMetricsSkeleton: FC = () => {
  return (
    <Styled.MetricsContainer>
      {Array.from({ length: METRIC_COUNT }, (_, index) => (
        <Skeleton
          key={index}
          variant="rounded"
          height={CARD_HEIGHT}
          sx={{ flex: 1, minWidth: CARD_MIN_WIDTH }}
        />
      ))}
    </Styled.MetricsContainer>
  );
};
